import { render, staticRenderFns } from "./ArticleEditModal.vue?vue&type=template&id=6ef4fc68&"
import script from "./ArticleEditModal.vue?vue&type=script&lang=js&"
export * from "./ArticleEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports